import React, {useContext} from 'react';
import {FormContext} from './MDForm';
import {propsToCSS} from '../css';
import {BASIC_ELEMENT_SCHEMA, Group} from '../layout/Group';
import {merge} from 'lodash';
import {TooltipHint} from './TooltipHint';

const NO_TRACK = v => v;

export function ConditionalExpression(props) {
  const formContext = useContext(FormContext);
  const { getValueByAttr } = formContext;

  let missed = false;

  const track = !props.requireAll ? NO_TRACK : v => {
    if (!v) {
      missed = true;
    }
    return v;
  };

  const style = {
    fontStyle: 'inherit',
    fontWeight: 'bold',
    fontSize: 'inherit',
    marginBottom: '0'
  }

  const styleRed = {
    fontStyle: 'inherit',
    fontWeight: 'bold',
    fontSize: 'inherit',
    color: 'red',
    marginBottom: '0'
  }

  const value = props.value
    .replace(/#{([^}]+)}/g, (_, attr) => track(formContext.getUIValueByAttr(attr))||'')
    .replace(/\${([^}]+)}/g, (_, path) => track(formContext.getValue(path))||'');

  if (missed) {
    return null;
  }
  const hintText = props.hintText;
  let condValue = getValueByAttr(props.attrCondition);

  if (props.attrCondition == undefined && props.dependentAttr != undefined ) {
    let dependentAttrVal = formContext.metadata[props.dependentAttr];
    if (dependentAttrVal.attributeRelationships) {
      for (let attrRel of dependentAttrVal.attributeRelationships) {
        if (attrRel.typeCd === 'ApplicableIf' && attrRel.attributeConditions) {
          if (!formContext.evalConditions(attrRel.attributeConditions)) {
            return null;
          }
        }
      }
    }
    if(props.value === '$250,000-Limited option is available once Drivers are added at Application' || props.value === 'A "Yes" option is available once Drivers are added at Application') {
        return <h1 tableindex={1} {...propsToCSS(props)} {...props.elementAttr} style={styleRed}>{value}
            {hintText && <TooltipHint style={{marginLeft: '1em'}} hintText={hintText}/>}
            </h1>;
    }else if (props.readOnlyAttr == undefined){
        return <h1 tableindex={1} {...propsToCSS(props)} {...props.elementAttr} style={style}>{value}
            {hintText && <TooltipHint style={{marginLeft: '1em'}} hintText={hintText}/>}
            </h1>;
    }
  }

  if (props.readOnlyAttr){
    let roValue = getValueByAttr(props.readOnlyAttr);
    roValue = ("$" + roValue).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return <h1 tableindex={1} {...propsToCSS(props)} {...props.elementAttr} style={style}>{roValue}{value}
                    </h1>;
  }

  if (condValue != undefined && condValue != "0") {
      return <h1 tableindex={1} {...propsToCSS(props)} {...props.elementAttr} style={style}>{value}
      </h1>;
      }
  else {
     return null;
  }
}

ConditionalExpression.schema = merge({
  properties: {
    value: {
      type: 'string',
    },
    requireAll: {
      type: 'boolean',
    },
  }
}, BASIC_ELEMENT_SCHEMA);